<div class="modal-header">
  <h2>Invite a new user to an account</h2>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('Cross click')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<app-invite-user-form
  [state]="state"
  [errorResponse]="errorResponse"
  (inviteUser)="onSubmit($event)"
>
  <button
    type="button"
    class="btn btn-outline-dark"
    (click)="activeModal.close('Close click')"
  >
    Cancel
  </button>
</app-invite-user-form>
